import numeral from "numeral";
import { useEffect, useMemo, useState } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import { calculateBasicLiquidityRatio } from "../../../functions/Balance/basic-liquidity-ratio";
import { calculateDebtToTotalAssets } from "../../../functions/Balance/debt-to-total-assets";
import { cn } from "../../../utils/useFunctions";
import {
  PdfCard,
  PdfCardGray,
  PdfCardWhite
} from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import {
  PdfHeaderText
} from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  mapIcon,
  mapStatus
} from "../lib/pdf.lib";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_MEDIUM_BLUE_11,
  STYLE_PDF_TEXT_MEDIUM_GRAY_11,
  STYLE_PDF_TEXT_NORMAL_11,
  STYLE_PDF_TEXT_SEMIBOLD_BLUE_14
} from "../styles/pdf.style";

// สร้าง PDF การเงินหน้าแรกโดยใช้ owner กลางของสภาพคล่องและหนี้สิน เพื่อให้ค่ากับรายละเอียดสูตรตรงกัน
function PdfPageFinacialOne({ page }) {
  const balanceData = useBalanceStore((state) => state.balanceData);

  const [addInvest, setAddInvest] = useState(
      balanceData?.property_invest_list ? balanceData?.property_invest_list : []
    );
  const [ReturnInsurance, setReturnInsurance] = useState([]);
  
useEffect(() => {
    if (balanceData) {
      let tempInsuranceReturn = balanceData?.expenses_fixed_list
        ?.filter(
          (item) => item.options_expenses_fixed === "expenses_insuarant_life"
        )
        ?.map((item) => item.expenses_insuarant_lifes)
        ?.flat();

      let tempBalanceData = {};
      //=============เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)=============//

      if (
        balanceData?.property_invest_list
          ?.map((item) => item.options_property_invest_title)
          .includes("เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)") &&
        tempInsuranceReturn?.length === 0
      ) {
        // ถ้ามีหัวข้อนี้อยู่แล้ว
        let tempNameList = balanceData?.property_invest_list
          .find(
            (item) =>
              item?.options_property_invest_title ===
              "เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)"
          )
          ?.invest_other_lists?.filter((item) => item !== null)
          ?.map((item) => item?.title);

        let tempInvestList = balanceData?.property_invest_list?.map((item) => {
          if (item?.invest_other_lists) {
            let tempData = tempInsuranceReturn
              ?.map((item2) => {
                if (!tempNameList?.includes(item2.title))
                  return {
                    amount: item2?.more_details?.policy_surrender_value,
                    created: item2.created,
                    reward_amount_per_year: item?.reward_amount_per_year || 1,
                    target_invest: {},
                    title: item2.title,
                    editable: false,
                  };
              })
              .filter((item) => item !== undefined);
            return {
              ...item,
              invest_other_lists: [...item.invest_other_lists, ...tempData],
            };
          }
          return item;
        });

        tempBalanceData = tempInvestList;
      } else {
        // ถ้ายังไม่มีหัวข้อนี้อยู่
        let tempInvestList = tempInsuranceReturn?.map((item) => {
          return {
            amount: item?.more_details?.policy_surrender_value,
            created: item.created,
            reward_amount_per_year: item?.reward_amount_per_year || 1,
            target_invest: item?.target_invest || {},
            title: item.title,
            editable: true,
          };
        });

        tempBalanceData = tempInvestList;
      }
      setReturnInsurance(tempBalanceData);
    }
  }, [balanceData]);

  const sumExpensesInvestSaving = balanceData?.sum_expenses_invest_saving
    ? balanceData?.sum_expenses_invest_saving
    : 0;
  const expenseValue = balanceData?.expenses_propotion
    ? balanceData?.expenses_propotion - sumExpensesInvestSaving
    : 0;

  // รายรับ
  const salaryValue = balanceData?.salary_propotion
    ? balanceData?.salary_propotion
    : 0;
  const expensesPerSalary = ((expenseValue / salaryValue) * 100)?.toFixed(2);

  const countPositiveValues = () => {
    const positiveValues = [
      balanceData?.sum_salary_peryear,
      balanceData?.sum_interest_peryear,
      balanceData?.sum_other_income,
    ]?.filter((value) => value > 0);
    return positiveValues?.length;
  };
  const getResult = () => {
    const numPositiveValues = countPositiveValues();
    if (numPositiveValues === 1) {
      return "normal";
    } else if (numPositiveValues > 1) {
      return "good";
    } else {
      return "false";
    }
  };

  const checkResultExpenses = () => {
    // รายรับ
    const salaryValue = balanceData?.salary_propotion
      ? balanceData?.salary_propotion
      : 0;
    // ค่าใช้จ่ายการออมและลงทุน
    const sumExpensesInvestSaving = balanceData?.sum_expenses_invest_saving
      ? balanceData?.sum_expenses_invest_saving
      : 0;
    // รายจ่ายที่ไม่รวมค่าใช้จ่ายเพื่อการออม
    const expenseValue = balanceData?.expenses_propotion
      ? balanceData?.expenses_propotion - sumExpensesInvestSaving
      : 0;

    if (
      !balanceData?.salary_propotion ||
      !balanceData?.sum_expenses_invest_saving
    )
      return "no_data";

    if (expenseValue > salaryValue / 2) {
      return "normal";
    } else {
      return "good";
    }
  };

  const getDesc = () => {
    if (getResult() === "normal") {
      return `คุณมีช่องทางรายรับไม่หลากหลาย`;
    }
    return `คุณมีรายรับหลากหลายช่องทาง`;
  };

  // รายรับ
  const salaryValueIncome = balanceData?.salary_propotion
    ? balanceData?.salary_propotion
    : 0;
  const expensesPerSalaryOutcome = (
    (expenseValue / salaryValueIncome) *
    100
  )?.toFixed(2);
  const getDescOutcome = () => {
    if (checkResultExpenses() === "no_data" || !checkResultExpenses()) return;

    if (checkResultExpenses() === "bad") {
      return `*รายจ่าย ${numeral(expenseValue)?.format("0,0")} บาท หรือ ${
        String(expensesPerSalaryOutcome) === "Infinity"
          ? 0
          : expensesPerSalaryOutcome
      } % `;
    }

    if (checkResultExpenses() === "normal") {
      return `*รายจ่าย ${numeral(expenseValue)?.format("0,0")} บาท หรือ ${
        String(expensesPerSalaryOutcome) === "Infinity"
          ? 0
          : expensesPerSalaryOutcome
      } % ซึ่งมากกว่าครึ่งนึงของรายรับ`;
    }

    return `คุณมีรายจ่าย รวม ${numeral(expenseValue)?.format(
      "0,0"
    )} บาท หรือ ${expensesPerSalaryOutcome} % ซึ่งน้อยกว่าครึ่งนึงของรายรับ`;
  };

  // สภาพคล่องพื้นฐาน
  const {
    liquidAssets,
    monthlyExpense,
    reserveDifference,
    ratio: basicLiquidityRatio,
    status: basicLiquidityStatus,
  } = calculateBasicLiquidityRatio({ balanceData });
  const checkProperty = basicLiquidityRatio;
  const checkResultProperty = () => basicLiquidityStatus;
  const checkPropertyIcon = () => {
    const status = checkResultProperty();
    if (status === "bad") {
      return "/images/bad_finance.svg";
    }
    if (status === "good") {
      return "/images/happy_finance.svg";
    }
    if (status === "chance") {
      return "/images/chance_finance.svg";
    }
  };
  const checkPropertTitle = () => {
    const status = checkResultProperty();
    if (status === "bad") {
      return (
        <div className="text-[14px] font-semibold text-center  text-[#FF0000]">
          คุณมีอัตราส่วนสภาพคล่อง {numeral(checkProperty)?.format("0[.]00")}{" "}
          เท่า ซึ่งน้อยกว่า 6 เท่า
        </div>
      );
    }
    if (status === "good") {
      return (
        <div className="text-[14px] font-semibold text-center   text-maingreen">
          คุณมีอัตราส่วนสภาพคล่องพื้นฐาน 6 เท่า
        </div>
      );
    }
    return (
      <div className="text-[14px] font-semibold text-center   text-[#654321] ">
        คุณมีอัตราส่วนสภาพคล่อง {numeral(checkProperty)?.format("0[.]00")} เท่า
        ซึ่งมากกว่า 6 เท่า
      </div>
    );
  };

  // คำนวณเงินสำรองที่ขาดหรือเหลือจากรายจ่ายต่อเดือนของ owner กลาง โดยไม่รวมเงินออมหรือลงทุน
  const checkPropertyDes = () => {
    const status = checkResultProperty();
    const additionalReserveNeeded = Math.max(-reserveDifference, 0);
    const excessLiquidAssets = Math.max(reserveDifference, 0);

    if (status === "bad") {
      return (
        <div className=" ">
          คุณต้องหาเงินสำรองเพิ่มอีก
          <span className=" px-1 font-bold text-red-500 ">
            {numeral(additionalReserveNeeded).format("0,0")}
          </span>
          บาท*
          <div>เพื่อความไม่ประมาทในการวางแผนการเงิน</div>
          <div className=" text-sm text-maingray mt-4 font-normal ">
            * ค่าใช้จ่ายแต่ละเดือน x 6 - สินทรัพย์สภาพคล่อง
            <div className=" text-xs mt-1">
              (
              <span className=" text-mainblue font-semibold pl-1">
                {numeral(monthlyExpense).format("0,0")}
              </span>{" "}
              x 6 - {numeral(liquidAssets).format("0,0")} ={" "}
              {numeral(additionalReserveNeeded).format("0,0")} )
            </div>
          </div>
        </div>
      );
    }

    if (status === "good") {
      return (
        <div className="">
          คุณมีความสามารถในการรับมือกับ
          <div>
            เหตุการณ์ไม่คาดฝันได้ดี เช่น ตกงาน อุบัติเหตุทำให้สูญเสียรายรับ
            เป็นต้น
          </div>
        </div>
      );
    }
    return (
      <div className="">
        คุณมีเงินสำรองจำนวนมาก
        <div>
          จะดีกว่าไหมหากนำเงิน
          <span className=" px-1 font-bold text-[#654321] ">
            {numeral(excessLiquidAssets).format("0,0")}
          </span>
          บาท*
          <div> ไปลงทุนเพิ่มเติม เพื่อให้บรรลุเป้าหมายทางการเงิน</div>
        </div>
      </div>
    );
  };

  // หนี้สินต่อสินทรัพย์
  const { totalAssets: debtToTotalAssetsDenominator, ratio: getDebttoTotalAsset } =
    useMemo(
      () =>
        calculateDebtToTotalAssets({
          balanceData,
          addInvest,
          returnInsurance: ReturnInsurance,
        }),
      [balanceData, addInvest, ReturnInsurance]
    );
  const checkDebttoAssetIcon = () => {
    const status = getDebttoTotalAsset;
    if (status > 50) {
      return "/images/bad_finance.svg";
    } else {
      return "/images/happy_finance.svg";
    }
  };
  const checkDebttoAssetTitle = () => {
    const status = getDebttoTotalAsset;
    if (status > 50) {
      return (
        <div className="text-[13px] font-semibold text-center  text-[#FF0000]">
          คุณมีอัตราส่วนหนี้สินต่อสินทรัพย์ {getDebttoTotalAsset?.toFixed(2)} %
          ซึ่งมากกว่า 50%
        </div>
      );
    } else {
      return (
        <div className="text-[13px] font-semibold text-center  text-maingreen">
          คุณมีอัตราส่วนหนี้สินต่อสินทรัพย์ {getDebttoTotalAsset?.toFixed(2)}%
          ซึ่งน้อยกว่า 50%
        </div>
      );
    }
  };

  const evulateIncomeExpensesItems = useMemo(() => {
    return [
      {
        label: "รายรับ",
        status: salaryValue === 0 ? "no_data" : getResult(),
        desc: salaryValue === 0 ? "" : getDesc(),
        icon: "income.svg",
        detail:
          salaryValue === 0
            ? ""
            : "คุณน่าจะเพิ่มช่องทางการหารายรับเช่น การลงทุนให้ได้เงินปันผล, การออมเงินเพื่อดอกเบี้ย หรือเพิ่มอาชีพที่ 2 เพื่อช่วยให้คุณบรรลุเป้าหมายทางการเงิน",
      },
      {
        label: "รายจ่าย",
        status: checkResultExpenses(),
        icon: "outcomepdf.svg",
        desc: getDescOutcome(),
        detail:
          checkResultExpenses() === "good"
            ? "คุณมีการใช้จ่ายในสัดส่วนที่ดี"
            : checkResultExpenses() === "normal"
            ? "คุณน่าจะลดค่าใช้จ่าย แล้วนำเงินมาเพิ่มการออมและลงทุนเพื่อเป้าหมายทางการเงิน"
            : "",
      },
    ];
  }, [balanceData]);

  const evulatePropertyItems = useMemo(() => {
    const newPropertyItems = [
      {
        label: "สภาพคล่องพื้นฐาน",
        label_gray: "(ควรมี 6 เท่า)",
        label_icon: "passbook.svg",
        icon: checkPropertyIcon(),
        title: checkPropertTitle(),
        desc: `อัตราส่วนสภาพคล่องพื้นฐาน = สินทรัพย์สภาพคล่อง/ค่าใช้จ่ายต่อเดือน`,
        desc_gray: ` ( ${numeral(checkProperty)?.format("0[.]00")} เท่า = 
        ${numeral(liquidAssets).format("0,0")} /
        ${numeral(monthlyExpense).format("0,0")} )`,
        detail: checkPropertyDes(),
        status: checkResultProperty(),
        noDataDesc: (
          <div className="flex flex-col items-center mt-1">
            <div className="flex justify-center items-center ">
              <div
                className={cn(
                  " w-full text-[13px] font-[500] text-center text-maingray "
                )}
              >
                {`ข้อมูลมีไม่เพียงพอเนื่องจากสินทรัพย์สภาพคล่องหรือรายจ่ายต่อเดือนเป็น 0 จึงไม่สามารถคำนวณได้`}
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_11, "mt-1 text-center ")}
            >
              {`อัตราส่วนสภาพคล่องพื้นฐาน = สินทรัพย์สภาพคล่อง/ค่าใช้จ่ายต่อเดือน`}
            </div>
          </div>
        ),
      },
      {
        label: "หนี้สินต่อสินทรัพย์",
        label_gray: "(ไม่ควรเกิน 50%)",
        label_icon: "cost (1).svg",
        icon: checkDebttoAssetIcon(),
        title: checkDebttoAssetTitle(),
        desc: `อัตราส่วนหนี้สินต่อสินทรัพย์ = หนี้สินทั้งหมด / สินทรัพย์ทั้งหมด * 100`,
        desc_gray: `${numeral(getDebttoTotalAsset)?.format(
          "0,0.00"
        )} % = (( ${numeral(balanceData?.debt_propotion)?.format("0,0")} /
        ${numeral(debtToTotalAssetsDenominator)?.format("0,0")}) * 100 )`,
        detail: `ภาระหนี้สินไม่มากเกินหนี้สินที่ดีก่อให้เกิดรายรับ และสินทรัพย์ในอนาคต`,
        status:
          !balanceData?.debt_propotion ||
          balanceData?.debt_propotion === 0 ||
          debtToTotalAssetsDenominator === 0
            ? "no_data"
            : "",
        noDataDesc: (
          <div className="flex flex-col items-center mt-1">
            <div className="flex justify-center items-center ">
              <div
                className={cn(
                  " w-full text-[13px] font-[500] text-center text-maingray "
                )}
              >
                {`ข้อมูลมีไม่เพียงพอเนื่องจากสินทรัพย์เป็น 0 จึงไม่สามารถคำนวนได้`}
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_11, "mt-1 text-center ")}
            >
              {`อัตราส่วนหนี้สินต่อสินทรัพย์ = (หนี้สิน/สินทรัพย์)x100`}
            </div>
          </div>
        ),
        // noDataDesc: "อัตราส่วนหนี้สินต่อสินทรัพย์ = (หนี้สิน/สินทรัพย์)x100",
      },
    ];
    return newPropertyItems;
  }, []);

  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText
        title="รายรับ-รายจ่าย"
        icon="/images/financial_analysis.svg"
      />
      <PdfCard title={""} classNameRoot="my-0">
        <div className="grid grid-cols-2 gap-3">
          {evulateIncomeExpensesItems?.map((item, index) => {
            return (
              <PdfCardWhite key={index} className={"flex flex-col "}>
                <div className="flex flex-col mx-2">
                  <div className="flex space-x-2 items-center">
                    <div>
                      <img src={`/images/${item.icon}`} className="bg-cover" />
                    </div>
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                      {item.label}
                    </div>
                  </div>
                  <div className="flex flex-col items-center">
                    {item?.status !== "no_data" && (
                      <div>
                        {/* <img src={`/images/${mapIcon(item?.status)}`} /> */}
                        {mapIcon(item?.status)}
                      </div>
                    )}
                    <div
                      className={cn(
                        "mt-2 bg-[#28CB4C4D] flex items-center p-[5px] justify-center rounded-[6.67px] text-[13px] font-[500] text-[#16AA37]",
                        {
                          "text-[#FF0000] bg-[#FF0000]/30":
                            item.status === "bad",
                          "text-maingreen ": item.status === "good",
                          "text-[#654321] bg-[#FFA800]/30":
                            item.status === "normal",
                          "text-maingray bg-[#b9b9b9]/30":
                            item.status === "no_data",
                        }
                      )}
                    >
                      {mapStatus(item.status, item.label)}
                    </div>
                    <div
                      className={cn(
                        "mt-2 flex items-center justify-center text-[13px] font-[500] text-[#16AA37] text-center",
                        {
                          "text-[#FF0000]": item.status === "bad",
                          "text-maingreen": item.status === "good",
                          "text-[#654321]": item.status === "normal",
                          "text-maingray ": item.status === "no_data",
                        }
                      )}
                    >
                      {item.desc}
                    </div>
                    <div
                      className={cn(
                        "mt-1 flex items-center justify-center text-center",
                        STYLE_PDF_TEXT_NORMAL_11
                      )}
                    >
                      {item.detail}
                    </div>
                  </div>
                </div>
              </PdfCardWhite>
            );
          })}
        </div>
      </PdfCard>
      <PdfHeaderText
        title="อัตราส่วนทางการเงิน"
        icon="/images/financial_analysis.svg"
      />
      <PdfCard title={""} classNameRoot="my-0">
        {evulatePropertyItems?.map((propertyItem, index) => {
          return (
            <PdfCardWhite key={index} className={"flex flex-col mt-3 "}>
              <div className="flex flex-col mx-2">
                <div className="flex space-x-2 items-center">
                  <div>
                    <img
                      src={`/images/${propertyItem.label_icon}`}
                      className="bg-cover"
                    />
                  </div>
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                    {propertyItem.label}
                  </div>
                  <div
                    className={cn("text-[#7E8393]", STYLE_PDF_TEXT_MEDIUM_11)}
                  >
                    {propertyItem.label_gray}
                  </div>
                </div>
                {propertyItem?.status === "no_data" ? (
                  <>{propertyItem?.noDataDesc}</>
                ) : (
                  <div className="flex flex-col items-center mt-1">
                    <div className="flex space-x-2 items-center justify-center">
                      <div>
                        <img
                          src={propertyItem.icon}
                          className="bg-cover w-[24px] h-[24px]"
                        />
                      </div>
                      <div className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14)}>
                        {propertyItem.title}
                      </div>
                    </div>
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_11, "mt-1")}>
                      {propertyItem.desc}
                    </div>
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_GRAY_11, "mt-1")}>
                      {propertyItem.desc_gray}
                    </div>
                    <PdfCardGray className={cn("py-2")}>
                      <div className="flex justify-center items-center px-10">
                        <img src="/images/Lamp.svg" className={cn("")} />
                        <div className={cn(" ml-1", STYLE_PDF_TEXT_NORMAL_11)}>
                          {propertyItem.detail}
                        </div>
                      </div>
                    </PdfCardGray>
                  </div>
                )}
              </div>
            </PdfCardWhite>
          );
        })}
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageFinacialOne;
